import { Name } from "./types";

export class Jk {
    private id: number;
    private name: Name;
    private code: string;


    constructor(id:number, name:string, code: string) {
        this.name = name
        this.id = id
        this.code = code
    }

    public Id = (): number => {
        return this.id
    }

    public Name = (): Name => {
        return this.name
    }
    public Code = (): string => {
        return this.code
    }
}